export const comments_3464718 = {"data":{"data":[],"links":{}}}